export const responseTypes = {
    CORRECT: 'correct',
    INCORRECT: 'incorrect',
    SKIPPED: 'skipped',
    TIMEDOUT: 'timedout',
}

export const assetsBase = '/assets/revamp/quiz'

export const tabDesktopBreakpoint = 1024 //px

export const colors = {
    primaryRed: '#D81639',
    secondaryRed: 'rgba(184, 39, 65, 0.8)',
    primaryGreen: '#089864',
    secondaryGreen: 'rgba(8, 152, 100, 0.8)',
    primaryWhite: '#f7f8fa',
}

export const choiceOptionMap = {
    '0': 'A',
    '1': 'B',
    '2': 'C',
    '3': 'D',
}

export const quizKeys = {
    QUIZ: 'quiz',
    ANSWER: 'answer',
    NEXT_QUESTION: 'next_question',
    QUESTION_RESULT: 'question_result',
    QUIZ_COMPLETE: 'quiz_complete',
    QUIZ_CANCEL: 'quiz_cancel',
}

export const studentHeaderCopy = {
    [responseTypes.CORRECT]: [
        'You got that right!',
        'Look at you Smartie',
        "That's some big brain energy",
    ],
    [responseTypes.INCORRECT]: [
        'Better luck next time',
        "Uhoh that ain't right",
    ],
    [responseTypes.SKIPPED]: ['You missed the question'],
    [responseTypes.TIMEDOUT]: ['Times up'],
}
